// Source: app/scripts/controllers/document-templates-page-controller.js
Auction.controller('DocumentTemplatesPageController', [
  '$scope',
  'Downloader',
  function ($scope, Downloader) {

    $scope.afterAuthorizationCrudInit = function (crudScope) {
      crudScope.downloadAuthorizationTypeTemplateAttachment = function (templateId) {
        if (templateId) {
          Downloader.download('/data/rest/portal_attachments/get_authorization_type_template/' + templateId);
        }
      };
    };

    $scope.afterLicenceCrudInit = function (crudScope) {
      crudScope.downloadGoodsTypeTemplateAttachment = function (templateId) {
        if (templateId) {
          Downloader.download('/data/rest/portal_attachments/get_goods_type_template/' + templateId);
        }
      };
    };

    $scope.afterIprTemplatesCrudInit = function (crudScope) {
      crudScope.downloadIprTemplateAttachment = function (templateId) {
        if (templateId) {
          Downloader.download('/data/rest/portal_attachments/get_document_template_vocabulary_template/' + templateId);
        }
      };
    };

  }
]);
